import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="print:hidden border-t border-gray-200 bg-white mt-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto py-8">
                {/* Main footer row */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-4">
                    {/* Left side - Logo and Copyright */}
                    <div className="flex flex-col items-center md:items-start space-y-3">
                        <img
                            src="/intellilogix-logo.png"
                            alt="IntelliLogix"
                            className="h-12 w-auto"
                        />
                        <div className="text-sm text-gray-500">
                            &copy; {new Date().getFullYear()} IntelliLogix Ltd. All rights reserved.
                        </div>
                    </div>

                    {/* Right side - Links */}
                    <div className="flex items-center space-x-6 text-base text-gray-500">
                        <a href="/privacy-policy" className="hover:text-gray-700 transition-colors">Privacy Policy</a>
                        <span className="text-gray-300">|</span>
                        <a href="/terms" className="hover:text-gray-700 transition-colors">Terms</a>
                        <span className="text-gray-300">|</span>
                        <a href="/security" className="hover:text-gray-700 transition-colors">Security</a>
                        <span className="text-gray-300">|</span>
                        <a href="/status" className="hover:text-gray-700 transition-colors">Status</a>
                    </div>
                </div>

                {/* Optional subtitle */}
                <div className="text-center text-sm text-gray-400 pt-4 border-t border-gray-100">
                    IntelliDrive is a product of IntelliLogix Ltd.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
